export enum BoundaryTerritoryType {
  Groups = 'groups',
  Numeric = 'numeric',
  Density = 'density',
  Demographic = 'demographic',
  Manual = 'manual'
}

export type CalculateBucketFunctionNumeric = 'min' | 'avg' | 'max' | 'sum';
export type CalculateBucketFunction = CalculateBucketFunctionNumeric | 'equal' | 'sum';
